import React from 'react';

const NavMobileAssignment = ({
  active,
  onChange,
  children,
}) => (
  <div className="pos-sticky d-md-none">
    <div className="row no-gutters">
      <div
        className={`
          col py-3 text-center cursor-pointer nav-mobile-header
          ${active === 'article' ? 'active' : ''}
        `}
        onClick={() => onChange('article')}
      >
        {children || "文章內容"}
      </div>
      <div
        className={`
          col py-3 text-center cursor-pointer nav-mobile-header
          ${active === 'answer' ? 'active' : ''}
        `}
        onClick={() => onChange('answer')}
      >
        題目作答
      </div>
    </div>
  </div>
);

export default NavMobileAssignment;
